import React from 'react';
import './global.css'

import Header from './components/Header'
import ProductList from './pages/ProductList'


function App() {
  return (
    <>
      <Header/>
      <ProductList/>
    </>
  );
}

export default App;
